import { ReactComponent as Tread } from './tread.svg';
import { ReactComponent as Bike } from './bike.svg';
import { ReactComponent as Tiger } from './guide.svg';
import { ReactComponent as Caesar} from './rowing.svg';
import { ReactComponent as Users} from './group.svg';
import { ReactComponent as Tools} from './tools.svg';
import { ReactComponent as Upload} from './upload_file.svg';
import { ReactComponent as Stethoscope} from './stethoscope.svg';
import { ReactComponent as Passerine} from './passerine.svg';
import { ReactComponent as Automation} from './precision_manufacturing.svg';
import { ReactComponent as Nestling} from './nestling.svg';


const icons = {
  Tread,
  Bike,
  Tiger,
  Caesar,
  Users,
  Tools,
  Upload,
  Stethoscope,
  Passerine,
  Automation,
  Nestling,
};

export default icons;
